export type starLabelNames = 'five_stars' | 'four_stars' | 'three_stars' | 'two_stars' | 'one_star';
export interface StarLabel {
  name: starLabelNames;
  label: string;
  scaleState: number;
}

export const starsLabelsData: StarLabel[] = [
  { name: 'five_stars', label: 'x.scale.stars.edit_labels.five_stars_label', scaleState: 5 },
  { name: 'four_stars', label: 'x.scale.stars.edit_labels.four_stars_label', scaleState: 4 },
  { name: 'three_stars', label: 'x.scale.stars.edit_labels.three_stars_label', scaleState: 3 },
  { name: 'two_stars', label: 'x.scale.stars.edit_labels.two_stars_label', scaleState: 2 },
  { name: 'one_star', label: 'x.scale.stars.edit_labels.one_star_label', scaleState: 1 },
];

export type npsLabelNames = 'label_ten' | 'label_zero';
export interface NpsLabel extends Pick<StarLabel, 'label' | 'scaleState'> {
  name: npsLabelNames;
}

export const npsLabelsData: NpsLabel[] = [
  { name: 'label_ten', label: 'x.scale.nps.edit_labels.label_ten', scaleState: 10 },
  { name: 'label_zero', label: 'x.scale.nps.edit_labels.label_zero', scaleState: 0 },
];
